import * as types from "./types";

const mutations = {
    [types.LOADING_PRODUCT](state, value) {
        state.loading = value;
    },
    [types.GET_PRODUCT_LIST](state, product) {
        state.product = product;
    },
    [types.GET_PRODUCT_ID](state, productID) {
        state.productID = productID;
    },
    [types.REMOVE_PRODUCT](state, id) {        
        state.product = state.product.filter((x) => x.id !== id);        
    },
    [types.ADD_PRODUCT](state, product) {        
        state.product.unshift(product);
    },
    [types.UPDATE_PRODUCT](state, product) {        
        const ProductIndex = state.product.findIndex((x) => x.id === product.id);
        state.product[ProductIndex] = product;        
    },
    [types.LOADING_PRODUCT_DOCUMENT](state, value) {
        state.docLoader = value;
    },
    [types.GET_PRODUCT_DOCUMENT_LIST](state, documents) {
        state.documents = documents;
    },
    [types.REMOVE_PRODUCT_DOCUMENT](state, id) {        
        state.documents = state.documents.filter((x) => x.id !== id);        
    }
      
};

export default mutations;